import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "./ui/ConfirmDialog";
import "./ui/ui.css";

/** Action confirmation: `confirmHandle()` then `setOpen(false)`. */
export default function Confirm({ children, open = false, setOpen, confirmHandle }) {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      onClose={() => setOpen(false)}
      onConfirm={confirmHandle}
      confirmLabel={t("Confirm")}
    >
      {children}
    </ConfirmDialog>
  );
}
